angular.module('dentalLinksServices')
    .service('PostOpReminder', ['$uibModal', 'ModalHandler', 'Auth', function ($uibModal, ModalHandler, Auth) {
        function isDestPracticeUser(referral) {
            var auth = Auth.get();
            return !!(auth && referral && referral.dest_practice_id === auth.practice_id);
        }

        function isOrigPracticeUser(referral) {
            var auth = Auth.get();
            return !!(auth && referral && referral.orig_practice_id === auth.practice_id);
        }

        function hasNoteFromNonOrigPractice(referral) {
            if (!referral.notes) return false;
            return referral.notes.some(function(note) {
                return note.user && note.user.practice_id && note.user.practice_id !== referral.orig_practice_id;
            });
        }

        function hasAttachmentFromNonOrigPractice(referral) {
            if (!referral.attachments) return false;
            return referral.attachments.some(function(attachment) {
                return attachment.author && attachment.author.practice_id && attachment.author.practice_id !== referral.orig_practice_id;
            });
        }

        function openModal(referral) {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/post_op_note_reminder_modal.html',
                controller: 'PostOpReminderModalController',
                resolve: {
                    referral: function () {
                        return referral;
                    }
                }
            });
            ModalHandler.set(modalInstance);
        }

        this.maybeShow = function (referral, options) {
            options = options || {};

            if (!referral) {
                return;
            }

            var shouldForce = options.force === true;
            var isCompleting = options.isCompleting === true;

            if (!shouldForce && !isCompleting) {
                return;
            }

            if (!isDestPracticeUser(referral)) {
                return;
            }

            if (isOrigPracticeUser(referral)) {
                return;
            }

            if (hasNoteFromNonOrigPractice(referral)) {
                return;
            }

            if (hasAttachmentFromNonOrigPractice(referral)) {
                return;
            }

            openModal(referral);
        };
    }]);
